import { Component, OnInit } from '@angular/core';
declare var $: any;
import MagicGrid from "magic-grid"

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    setTimeout(function() {
      document.getElementById("loading").classList.add("animated");
      document.getElementById("loading").classList.add("fadeOut");
      setTimeout(function() {
        document.getElementById("loading").classList.remove("animated");
        document.getElementById("loading").classList.remove("fadeOut");
        document.getElementById("loading").style.display = "none";
      }, 800);
    }, 1500);
    $.getJSON("blog.json", function(blog) {
      blog = blog || [];
      if (blog.length == 0) {
        return (document.getElementById("blog_section").style.display =
          "none");
      }
      for (var i = 0; i < blog.length; i++) {
        $("#blogs").append(`
          <a href="./blog/${blog[i].url_title}/" target="_blank">
              <section>
                  <img src="./blog/${blog[i].url_title}/${blog[i].top_image}">
                  <div class="blog_container">
                      <div class="section_title">${blog[i].title}</div>
                      <div class="about_section">
                          ${blog[i].sub_title}
                      </div>
                  </div>
              </section>
          </a>
          `);
      }
    }).fail(function() {
      return (document.getElementById("blog_section").style.display = "none");
    });

    const magicProjectsGrid = new MagicGrid({
      container: "#work_section",
      animate: false,
      gutter: 30, // default gutter size
      static: true,
      useMin: false,
      maxColumns: 2,
      useTransform: true
    });

    const magicForksGrid:any = new MagicGrid({
      container: "#forks_section",
      animate: false,
      gutter: 30, // default gutter size
      static: true,
      useMin: false,
      maxColumns: 2,
      useTransform: true
    });

    $("document").ready(() => {
      magicProjectsGrid.listen();
      magicForksGrid.listen();
    });
  }

}
